import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MPaymentTransactionEntity } from './m-payment-transaction.entity';

@Index(
	'm_payment_fk_m_payment_transaction__id_origin',
	['mPaymentFkMPaymentTransactionIdOrigin'],
	{},
)
@Index('idx_txn_summary_created_date', ['createdDate'], {})
@Index('idx_txn_summary_status_created', ['mPaymentStatus', 'createdDate'], {})
@Entity(
	'm_payment_transaction_summary',
	{},
	{ label: 'Payment Transaction Summary' },
)
export class MPaymentTransactionSummaryEntity extends BaseEntity {
	@Column('int', {
		name: 'm_payment_fk_m_payment_transaction__id_origin',
		nullable: true,
		unsigned: true,
	})
	public mPaymentFkMPaymentTransactionIdOrigin!: number | null;

	@Column('varchar', { name: 'm_payment_status', nullable: true, length: 64 })
	public mPaymentStatus!: string | null;

	@Column('decimal', {
		name: 'm_payment_amount',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public mPaymentAmount!: string | null;

	@Column('decimal', {
		name: 'm_payment_netAmount',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public mPaymentNetAmount!: string | null;

	@ManyToOne(
		() => MPaymentTransactionEntity,
		(mPaymentTransaction) => mPaymentTransaction.mPaymentTransactionSummaries,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: 'm_payment_fk_m_payment_transaction__id_origin',
			referencedColumnName: 'id',
		},
	])
	public mPaymentFkMPaymentTransactionIdOrigin2!: MPaymentTransactionEntity;
}
